export type Ms = number;
export type Seconds = number;

export const secondsToMs = (seconds: Seconds): Ms => seconds * 1000;

export const sleep = (ms: Ms) => new Promise((resolve) => setTimeout(resolve, ms));
